import { getNumFormatter } from '@components/common';
import { getCompaniesHiringCount } from 'API/jobs';

export const getTotalJobsCount = async (jobsCount: number) => {
  const numFormat = getNumFormatter();
  const defaultCount = numFormat.format(1140);
  try {
    if (!jobsCount) return defaultCount;
    if (jobsCount >= 200) return numFormat.format(jobsCount);
    // get the total open positions
    const hiringCount = await getCompaniesHiringCount();
    return numFormat.format(hiringCount.jobsCount);
  } catch (error) {
    return defaultCount;
  }
};
